"use client";

import { useSearchParams } from "next/navigation";
import FormRadioTag from "../Form/FormRadioTag";
import FormSelect from "../Form/FormSelect";
import useUrlQuery from "@/hooks/useUrlQuery";
import { Fragment, useCallback, useMemo } from "react";
import { findTreePath, deepFirstTraversal } from "@/lib/tree";
import { I18nText, useI18nText } from "@/hooks/useI18nText";
import { cn } from "@/lib/utils";

export type Option = {
  label: string;
  value: string;
  children?: Option[];
}

export function TabsFilterClient(props: {
  options?: Option[];
  name: string;
  defaultOption?: boolean;
  defaultOptionName?: I18nText;
}) {
  const { translation } = useI18nText();
  const query = useSearchParams();
  const values = query.get(props.name);
  const value = useMemo(() => {
    if (!values) {
      return "defaultValue";
    }
    const arr = values.split(",");
    let value = "defaultValue";
    deepFirstTraversal(props.options || [], (item) => {
      if (arr.includes(item.value)) {
        value = item.value;
        return false;
      }
      return true;
    })
    return value;
  }, [values, props.options])
  const { changeUrlQueryObj } = useUrlQuery();
  const options = useMemo(() => {
    if (props.defaultOption) {
      return [
        { label: translation(props.defaultOptionName || {
          cn: "全部",
          en: "All"
        }), value: "defaultValue" },
        ...(props.options || [])
      ];
    }
    return props.options || [];
  }, [props, translation]);


  const getSelectValues = useCallback((newValue: string) => {
    const newPath = findTreePath(options, newValue, {
      valueKey: "value"
    })
    const lastNode = newPath[newPath.length - 1];
    if (!lastNode?.children?.length) {
      return newValue;
    }
    const values: string[] = [newValue];
    deepFirstTraversal(lastNode.children, (item) => {
      values.push(item.value);
      return true;
    });
    return values.join(",");
  }, [options])

  return (
    <div className="w-full">
      <div className="w-full flex justify-center items-center">
        {options.map((el, index) => (
          <Fragment key={index}>
            {index !== 0 && (
              <hr className="mx-5 h-3.5 border-l border-gray md:mx-7 md:h-6 " />
            )}
            <span
              className={cn(
                "text-sm md:text-lg",
                {
                  "text-primary": value === el.value,
                  "cursor-pointer":  value !== el.value,
                }
              )}
              onClick={() => {
                changeUrlQueryObj({
                  [props.name]: el.value !== "defaultValue" ? getSelectValues(el.value) : null,
                  page: null,
                })
              }}
            >{el.label}</span>
          </Fragment>
        ))}
      </div>
      {/* <div className="hidden md:block">
        <FormRadioTag
          options={options}
          field={{
            value: path[0]?.value,
            onChange: (val) => {
              changeUrlQueryObj({
                [props.name]: val !== "defaultValue" ? getSelectValues(val) : null,
                page: null,
              })
            }
          }}
        />
      </div>
      {path.map((item, index) => (
        <div
          className="hidden md:block mt-3"
          key={index}
        >
          <FormRadioTag
            options={item.children}
            field={{
              value: path[index + 1] ? path[index + 1].value : value,
              onChange: (val) => {
                changeUrlQueryObj({
                  [props.name]: getSelectValues(val),
                  page: null,
                })
              }
            }}
          />
        </div>
      ))}
      <div className="flex w-full gap-x-6 md:hidden">
        <FormSelect
          className="min-w-0"
          options={options}
          field={{
            value,
            onChange: (val) => {
              changeUrlQueryObj({
                [props.name]: val !== "defaultValue" ? val : null,
                page: null,
              })
            }
          }}
        />
      </div> */}
    </div>
  );
}
